export default __webpack_public_path__ + "static/media/Logowhite.450337f3.png";